import React from 'react';
import PropTypes from 'prop-types';
import { cloneOrRender } from 'utils/react';
import { HiddenInput, TextInput } from 'components/Input';

const FilteredSelectInput = ({
    innerRef,
    name,
    value,
    inputValue,
    useHiddenInput,
    input,
    ...rest
}) => {
    const props = {
        ...rest,
        innerRef,
        name: useHiddenInput ? null : name,
        value: inputValue,
        role: 'combobox',
    };
    return (
        <>
            {cloneOrRender(input, props)}
            {useHiddenInput && <HiddenInput name={name} value={value} />}
        </>
    );
};

FilteredSelectInput.displayName = 'FilteredSelectInput';

FilteredSelectInput.propTypes = {
    innerRef: PropTypes.ref(),
    name: PropTypes.string,
    value: PropTypes.string,
    inputValue: PropTypes.string,
    useHiddenInput: PropTypes.bool,
    input: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node, PropTypes.func]),
};

FilteredSelectInput.defaultProps = {
    innerRef: null,
    name: '',
    value: '',
    inputValue: '',
    useHiddenInput: true,
    input: TextInput,
};

export default FilteredSelectInput;
